/**
 * registerCards.js — Register base feature-card components.
 *
 * WHY THIS EXISTS:
 *   CardCarousel resolves a card renderer by name — Capitalize(cardType) +
 *   "Card" (so cardType "wine" -> "WineCard") — via registry.getComponent().
 *   Unlike the panel-level components in ChatPanel.js, card components have NO
 *   BASE_COMPONENTS fallback, so they MUST be registered explicitly or the
 *   carousel logs "No card component registered" and renders nothing.
 *
 * ORDERING:
 *   init.js calls registerBaseCards() BEFORE loadVariant(). A variant that
 *   re-registers the same name (e.g. a Fogarty WineCard) therefore overrides
 *   the base one — last registration wins in the registry Map.
 */

import { registry } from "../../core/registry.js";
import WineCard from "./WineCard.js";
import MembershipCard from "./MembershipCard.js";
import EventCard from "./EventCard.js";
import TastingCard from "./TastingCard.js";
import EventDetailsCard from "./EventDetailsCard.js";
import ReviewCard from "./ReviewCard.js";

export function registerBaseCards() {
  registry.registerComponent("WineCard", WineCard);
  registry.registerComponent("MembershipCard", MembershipCard);
  registry.registerComponent("EventCard", EventCard);
  registry.registerComponent("TastingCard", TastingCard);
  registry.registerComponent("EventDetailsCard", EventDetailsCard);
  registry.registerComponent("ReviewCard", ReviewCard);
}
